import { Link } from 'react-router-dom';
import { HOME_FAQ } from './seo';
import './Faq.css';

/*
 * Native <details> disclosure: every answer is in the HTML (crawlable, no JS
 * needed to expand) and it is keyboard accessible for free. Pair with
 * faqSchema(HOME_FAQ) in the page's Helmet.
 */
function Faq({
  items = HOME_FAQ,
  eyebrow = 'FAQ',
  title = 'Common questions',
  lede = 'Everything you need to know before your first race. Can\u2019t find an answer? The Help Centre has guides for every feature.',
  className = '',
}) {
  return (
    <section className={`faq ${className}`.trim()} aria-labelledby="faq-title">
      <div className="faq__inner">
        <div className="faq__intro">
          <p className="faq__eyebrow">{eyebrow}</p>
          <h2 id="faq-title" className="faq__title">{title}</h2>
          <p className="faq__lede">{lede}</p>
          <Link to="/help" className="faq__help">
            Visit the Help Centre
            <svg viewBox="0 0 20 20" aria-hidden="true">
              <path d="M4 10h11M11 5l5 5-5 5" />
            </svg>
          </Link>
        </div>
        <div className="faq__list">
          {items.map((item, index) => (
            <details key={item.question} className="faq__item" open={index === 0}>
              <summary className="faq__question">
                <h3>{item.question}</h3>
                <span className="faq__icon" aria-hidden="true" />
              </summary>
              <p className="faq__answer">{item.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Faq;
